import PropTypes from 'prop-types';
import { MEDIA_TYPES } from '~/constants';

export interface AssetType {
  url: string;
  previewUrl: string;
  type: MEDIA_TYPES;
}

export const assetType = PropTypes.shape({
  url: PropTypes.string,
  previewUrl: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(MEDIA_TYPES)),
});
